<template lang="pug">
el-container
  el-header(height="80px")
    el-menu.el-menu-demo(:default-active="activeIndex", mode="horizontal", @select="handleSelect", id="elMenu")
      el-menu-item(@click="back()") 后退
      el-menu-item(index="/jiajiangIndex") 首页
      el-submenu(index="/jiajiang/airPro")
        template(slot="title") 空气处理设备
        el-menu-item(index="/jiajiang/airProJY") 建邺侧
        el-menu-item(index="/jiajiang/airProPK") 浦口侧
      el-menu-item(index="/jiajiang/gasClamp") 全桥实时数据
      el-submenu(index="/jiajiang/anchorRoom")
        template(slot="title") 锚室
        el-menu-item(index="/jiajiang/anchorRoomJY") 建邺侧
        el-menu-item(index="/jiajiang/anchorRoomPK") 浦口侧
      el-menu-item(index="/jiajiang/saddleRoom") 鞍室
      el-menu-item(index="/jiajiang/steelBoxGirder") 钢箱梁
      el-menu-item(index="/jiajiang/bridgeImg") 全桥除湿总体布置图
      el-submenu(index="/jiajiang/dataHistory?bridgeId=ea53bb2e-19ff-4c30-8dcf-f915e8ddfc81&scenarioId=TBD")
        template(slot="title") 数据历史
        el-menu-item(index="/jiajiang/dataHistory?bridgeId=ea53bb2e-19ff-4c30-8dcf-f915e8ddfc81&scenarioId=TBD") 查询数据历史
        el-menu-item(index="/jiajiang/dataHistory?bridgeId=ea53bb2e-19ff-4c30-8dcf-f915e8ddfc81") 自定义数据历史
    HeaderTime(bridgeName="NANJING", :bridgeId="bridgeId", :id2Path="id2Path", :envInfo="envInfo")
  el-main
    router-view
</template>
<script>
export default {
  name: "jiajiang",
  data() {
    return {
      bridgeId: "ea53bb2e-19ff-4c30-8dcf-f915e8ddfc81",
      envInfo: {
        envId: "e84ebd2f-7b03-44af-8f70-aeb86354d093",
        weather: "1be3a9c9-099d-450a-a64c-997821c036dc",
        humidity: "552560a4-06cc-41e5-92e9-1ca09e2857fc",
        temperature: "87e7e9db-3dd0-4505-a41f-92ec2b159e44",
      },
      id2Path: {
        "10f54b91-d423-49b7-bb65-2afd0237e3ac": "jiajiang/saddleRoom",
        "d2f271f3-0119-4143-8847-496e31f4a347": "jiajiang/anchorRoomJY",
        "d27038d2-fb67-4432-bc3b-b75b08297319": "jiajiang/anchorRoomJY",
        "1dd09a7b-f0be-4838-973e-b72b03325167": "jiajiang/anchorRoomPK",
        "9f460195-d245-4885-a5a7-bc24d55e5727": "jiajiang/airProJY",
        "fc798b13-e25f-4732-ad4f-39072aacc2b2": "jiajiang/airProJY",
        "96ac1c01-1a72-4583-bcfc-81e94a248f62": "jiajiang/airProPK",
        "bcb52722-e9c8-40ee-aa1f-e8988ea969ce": "jiajiang/steelBoxGirder",
        "9f67b4aa-8d86-4253-aaa1-b69d09f833fe": "jiajiang/gasClamp",
        "cf6d8d5b-8ce9-42b6-b820-480189c06751": "jiajiang/gasClamp",
      },
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>


   <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>